<template>
  <slot />
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue'

export default defineComponent({
  props: {
    bodyClass: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const manageBodyClasses = (action: 'add' | 'remove') => {
      const classes = props.bodyClass?.split(' ')
      if (classes) {
        classes.forEach((className) => {
          document.body.classList[action](className)
        })
      }
    }

    onMounted(() => {
      manageBodyClasses('add')
    })

    onUnmounted(() => {
      manageBodyClasses('remove')
    })
  },
})
</script>
